import { Injectable } from '@angular/core';

import { BrandThemesEnum, ThemesEnum } from '@seb/web-design-system/core';

import { UppercaseBrandThemesEnum, UppercaseThemesEnum } from '../enums';

type ThemeMapping = {
  [key in UppercaseThemesEnum | UppercaseBrandThemesEnum]: ThemesEnum | BrandThemesEnum;
};

const themeMap: ThemeMapping = {
  [UppercaseThemesEnum.PROMO1]: ThemesEnum.promo,
  [UppercaseThemesEnum.PROMO2]: ThemesEnum.promo2,
  [UppercaseThemesEnum.EXTRA]: ThemesEnum.extra,
  [UppercaseThemesEnum.STARS]: ThemesEnum.stars,
  [UppercaseThemesEnum.DARK]: ThemesEnum.dark,
  [UppercaseThemesEnum.LIGHT]: ThemesEnum.light,
  [UppercaseThemesEnum.WHITE]: ThemesEnum.white,
  [UppercaseBrandThemesEnum.BRAND]: BrandThemesEnum.brand,
  [UppercaseBrandThemesEnum.BRANDLIGHT]: BrandThemesEnum.brandLight,
  [UppercaseBrandThemesEnum.BRANDDARK]: BrandThemesEnum.brandDark,
  [UppercaseBrandThemesEnum.BRANDBASE]: BrandThemesEnum.brandBase,
  [UppercaseBrandThemesEnum.VERY_LIGHT]: ThemesEnum.veryLight,
  [UppercaseBrandThemesEnum.BRAND_LIGHT]: BrandThemesEnum.brandLight,
  [UppercaseBrandThemesEnum.BRAND_BASE]: BrandThemesEnum.brandBase,
  [UppercaseBrandThemesEnum.BRAND_DARK]: BrandThemesEnum.brandDark,
  [UppercaseBrandThemesEnum.REGULAR]: ThemesEnum.regular,
  [UppercaseBrandThemesEnum.COLORED]: ThemesEnum.colored,
  [UppercaseThemesEnum.DEFAULT]: ThemesEnum.default
};

@Injectable({
  providedIn: 'root'
})
export class ThemesMapper {
  static mapBrandTheme(theme: UppercaseThemesEnum | UppercaseBrandThemesEnum): ThemesEnum | BrandThemesEnum {
    return this.mapBrandThemeOrDefault(theme, ThemesEnum.default);
  }

  static mapBrandThemeOrDefault(
    theme: UppercaseThemesEnum | UppercaseBrandThemesEnum,
    defaultTheme: ThemesEnum | BrandThemesEnum
  ): ThemesEnum | BrandThemesEnum {
    return themeMap[theme] || defaultTheme;
  }
}
